import React, { ReactNode } from 'react';
import { Link as ReactLink } from 'react-router-dom';

import { buildCssClassName } from '@developer/utils';

import './styles.scss';

type LinkProps = {
  href: string;
  children: string | ReactNode;
  classes?: string | boolean;
  onClick?: (e?: any) => any | void;
};

export const Link = ({
  href,
  children,
  classes,
  onClick,
  ...rest
}: LinkProps): JSX.Element => (
  <ReactLink
    to={href}
    className={buildCssClassName(['link', classes])}
    onClick={onClick}
    {...rest}
  >
    {children}
  </ReactLink>
);

Link.defaultProps = {
  classes: '',
};
